import React from 'react';
import PropTypes from 'prop-types';
import {Observable} from 'rxjs';

export const Button = ({children, type, className, onClick}) => (
    <button
        type={type || 'button'}
        className={`btn btn-secondary btm-md form-button ${className}`}
        onClick={onClick}>
        {children}
    </button>
);
Button.propTypes = () => ({
    type: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.instanceOf(Observable),
    children: PropTypes.element.isRequired,
});